export const BOLETIM_MONTH_OPTIONS = [
  { value: "1", label: "Janeiro" },
  { value: "2", label: "Fevereiro" },
  { value: "3", label: "Março" },
  { value: "4", label: "Abril" },
  { value: "5", label: "Maio" },
  { value: "6", label: "Junho" },
  { value: "7", label: "Julho" },
  { value: "8", label: "Agosto" },
  { value: "9", label: "Setembro" },
  { value: "10", label: "Outubro" },
  { value: "11", label: "Novembro" },
  { value: "12", label: "Dezembro" },
];

export const BOLETIM_FATURAMENTO_STATUS_OPTIONS = [
  { value: "Não faturado", label: "Não faturado" },
  { value: "Parcialmente Faturado", label: "Parcialmente faturado" },
  { value: "Faturado", label: "Faturado" },
];

export const BOLETIM_PAGAMENTO_STATUS_OPTIONS = [
  { value: "Não faturado", label: "Não faturado" },
  { value: "Não pago", label: "Não pago" },
  { value: "Parcialmente Pago", label: "Parcialmente pago" },
  { value: "Pago", label: "Pago" },
];

export const BOLETIM_VALOR_TOTAL_SORT_OPTIONS = [
  { value: "desc", label: "Maior para menor" },
  { value: "asc", label: "Menor para maior" },
];
